import { Modal } from 'antd'
import { useEffect, useState } from 'react'

export interface MediaUrlCreateResult {
  title: string
  external_url: string
}

export default function MediaUrlCreateDialog({
  open,
  blockType,
  onCancel,
  onConfirm,
}: {
  open: boolean
  blockType: 'video' | 'audio'
  onCancel: () => void
  onConfirm: (result: MediaUrlCreateResult) => void
}) {
  const [title, setTitle] = useState('')
  const [url, setUrl] = useState('')
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!open) return
    setTitle('')
    setUrl('')
    setError(null)
  }, [open, blockType])

  const label = blockType === 'video' ? '视频' : '音频'

  const submit = () => {
    const trimmed = url.trim()
    if (!trimmed) {
      setError(`请输入${label}链接`)
      return
    }
    try {
      const parsed = new URL(trimmed)
      if (!['http:', 'https:'].includes(parsed.protocol)) throw new Error('invalid')
    } catch {
      setError('请输入有效的 http(s) 链接')
      return
    }
    onConfirm({ title: title.trim(), external_url: trimmed })
  }

  return (
    <Modal
      open={open}
      title={`添加${label}`}
      okText="创建"
      cancelText="取消"
      onCancel={onCancel}
      onOk={submit}
      destroyOnClose
      width={480}
    >
      <p style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 0 }}>
        填写有效链接后再创建{label}内容块。取消不会创建任何内容块。
      </p>
      <div className="ge-field">
        <label className="ge-field-label">标题（可选）</label>
        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder={`${label}标题`} />
      </div>
      <div className="ge-field">
        <label className="ge-field-label">{label}链接</label>
        <input type="text" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://…" />
      </div>
      {error ? <p style={{ color: '#cf1322', fontSize: 13 }}>{error}</p> : null}
      {blockType === 'video' ? (
        <p style={{ color: 'var(--text-muted)', fontSize: 12, marginBottom: 0 }}>封面图可在创建后于内容块编辑器中设置。</p>
      ) : null}
    </Modal>
  )
}
